<div class="flex flex-col gap-4 px-[8px]">
  <app-p-p-reason-list-filter
    [filters]="filters()"
    (applyFilters)="onApplyFilters($event)"
    (resetFilters)="onResetFilters()"
    (toggleSortOrder)="onToggleSortOrder()" />

  @if (loading()) {
    <div class="borderDivColor mt-2 flex items-center justify-center rounded-[8px] border bg-white py-12 shadow-sm">
      <p class="status-neutral-text text-[14px]" i18n="@@ppReasonsLoading">Loading reasons...</p>
    </div>
  } @else if (errorGettingReasons()) {
    <div class="borderDivColor mt-2 flex items-center justify-center rounded-[8px] border bg-white py-12 shadow-sm">
      <p class="status-neutral-text text-[14px]">{{ errorGettingReasons() }}</p>
    </div>
  } @else {
    <app-tables
      [headerItems]="tableHeaders()"
      [rows]="tableRows()"
      [currentActions]="tableActions()"
      [isFiltersApplied]="isFiltersApplied()"
      [emptyFilterTitle]="
        isArabic() ? 'لا توجد نتائج تطابق الفلاتر المحددة' : 'No reasons match your selected filters.'
      "
      [emptyContentTitle]="isArabic() ? 'لم يتم العثور على أسباب' : 'No partially package reasons found.'"
      (actionTrigger)="onActionTriggered($event)" />
  }

  @if (totalItems() > 0) {
    <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="getPageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="previousPage()"
      (nextPage)="nextPage()"
      (goToPage)="goToPage($event)"
      (changePageNumber)="onPageSizeChange($event)" />
  }

  @if (showSuccessMessage()) {
    <app-successful-notification
      type="success"
      [title]="
        isArabic()
          ? 'تم حذف سبب التعبئة الجزئية \'' + deletedReasonName() + '\' بنجاح'
          : 'Partially package reason \'' + deletedReasonName() + '\' deleted successfully'
      " />
  }

  @if (showWarningMessage()) {
    <app-warning-notification type="warning" [title]="warningMessageText()" />
  }

  @if (isDeleteDialogOpen()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="deleteDialogTitle()"
      [description]="deleteDialogDescription()"
      [itemName]="deleteDialogItemName()"
      [confirmContent]="deleteDialogConfirmContent()"
      [cancelContent]="deleteDialogCancelContent()"
      [isLoading]="deleteLoading()"
      [error]="deleteError()"
      (onCancel)="closeDeleteDialog()"
      (onSubmit)="onDeleteDialogSubmit()" />
  }
</div>
